import { Component, OnInit, Inject, Renderer2, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import { CaseAddImageFields, InternalFields, ExternalFields, CaseFormFields } from './../../../case-based/case-base.classes';
import { PtImageMappingService } from './../../../../../service/pt-image-mapping.service';
import { AddImageErrorComponent } from '../../../dailog/specimen/add-image-error/add-image-error.component';
import { ConstantService } from 'src/app/service/constant.service';
import { ObervableService } from 'src/app/service/obervable.service';

@Component({
	selector: 'app-case-add-image-dailog',
	templateUrl: './case-add-image-dailog.component.html',
	styleUrls: ['./case-add-image-dailog.component.scss']
})
export class CaseAddImageDailogComponent implements OnInit {

	public caseAddImageForm: CaseAddImageFields = new CaseAddImageFields();
	public uploadedFile: File;
	public exImageType: Array<object> = [];
	public exCategory: Array<object> = [];
	public exImageSubType: Array<object> = [];
	public inMagnification: Array<object> = [];
	public saveFormData : CaseFormFields = new CaseFormFields();
	public isCommitteeMember: boolean;
	public isCAPStaff: boolean;
	public catFromSubType: Number = 0;

	@ViewChild('lightbox') lightbox;
	public lightBoxImagePath: any;

	constructor(
		private ptImageMappingService: PtImageMappingService,
		public dialogRef: MatDialogRef<CaseAddImageDailogComponent>,
		private renderer: Renderer2,
		private constantService: ConstantService,
		public dialog: MatDialog,
		private obervableService: ObervableService,
		@Inject(MAT_DIALOG_DATA) public dailogData:any) {
			this.caseAddImageForm.internal = new InternalFields();
			this.caseAddImageForm.external = new ExternalFields();
			this.caseAddImageForm.isEdit = (this.dailogData.is_edit) ? true : false;
			this.caseAddImageForm.disableBtn = (this.dailogData.is_edit) ? false : true;
	}

	ngOnInit(): void {
		// TO GET THE USER PERMISSION.
		this.isCAPStaff = this.constantService.getCAPStaffPermision();
		this.isCommitteeMember = this.constantService.getCommitteeMemberPermision();

		// GET THE IMAGE TYPE DROPDOWN DATA.
		this.getImageType();
		// TO GET THE MEGNIFICATION DROPDOWN DATA.
		this.getMegnification();
		this.getCatFromSubType(this.dailogData.subTypeCode);
		if (!this.caseAddImageForm.isEdit){
			// TO GET SEQUANCE NO
			this.getSequenceNo();
		}else{
			this.caseAddImageForm.internal.image_id = this.dailogData.id;
			this.caseAddImageForm.internal.magnification = (this.dailogData.magnification && this.dailogData.magnification != "All") ? this.dailogData.magnification : '';
			this.caseAddImageForm.internal.squence = this.dailogData.sequence;
			this.caseAddImageForm.internal.comment = this.dailogData.comment;

			this.caseAddImageForm.external.imagetype = this.dailogData.typeCode;
			this.caseAddImageForm.external.imagename = this.dailogData.externalName;
			if(this.dailogData && this.dailogData.typeCode && this.dailogData.typeCode!=""){
				this.ptImageMappingService.getCategory(this.dailogData.typeCode).subscribe( (result:Array<object>) => {
					this.exCategory = result;
					const category:any = this.exCategory.find( (item:any) => item.slideTypeCode == this.catFromSubType);
					if(category != undefined){
						this.caseAddImageForm.external.category = category.slideTypeCode;

						this.ptImageMappingService.getImageSubType(category.slideTypeCode).subscribe( (iresult:Array<object>) => {
							this.exImageSubType = iresult;
							this.caseAddImageForm.external.imagesubtype = this.dailogData.subTypeCode;
						});
					}
				});
			}
		}
	}

	// TO GET THE CATEGORY
	getCatFromSubType = (subTypeCode: String) =>  {
		if(subTypeCode){
			this.ptImageMappingService.getCategoryFromSubtype(subTypeCode).subscribe((result: Number) => {
				this.catFromSubType = result;
			});
		}
	}

	// TO GET THE IMAGE TYPE AND POPULATE DROPDOWN
	getImageType = () => {
		this.ptImageMappingService.getImageType().subscribe( (result: Array<object>) => {
			this.exImageType = result;
		});
	}
	// TO GET THE MEGNIFICATION DATA AND POPULATE DROPDOWN
	getMegnification = () => {
		this.ptImageMappingService.getMegnification().subscribe( (result: Array<object>) => {
			this.inMagnification = result;
		});
	}

	// TO GET SEQUANCE NO AND POPULATE IN INPUT.
	getSequenceNo = () => {
		if(this.dailogData.caseNumberID){
			this.ptImageMappingService.getCaseNumberSequence(this.dailogData.caseNumberID).subscribe( (result) =>{
				this.caseAddImageForm.internal.squence = result;
			});
		}else{
			this.ptImageMappingService.getAnatomicSiteSequence(this.dailogData.anatomicSiteCode, this.dailogData.actionDiagnosis).subscribe( (result) =>{
				this.caseAddImageForm.internal.squence = result;
			});
		}
	}

	// ON CHANGE CATEGORY DROPDOWN TO GET SUB TYPE CATEGORY
	onChangeCategory = (event) => {
		this.caseAddImageForm.external.imagesubtype = "";
		this.exImageSubType = [];
		if(event.target.value !== ""){
			this.ptImageMappingService.getImageSubType(event.target.value).subscribe( (result:Array<object>) => {
				this.exImageSubType = result;
			});
		}
	}

	// ON CHANGE IMAGE DROPDOWN TO GET CATEGORY
	onChangeImageType = (event) => {
		this.caseAddImageForm.external.category = "";
		this.caseAddImageForm.external.imagesubtype = "";
		this.exCategory = [];
		this.exImageSubType = [];

		if(event.target.value !== ""){
			this.ptImageMappingService.getCategory(event.target.value).subscribe( (result:Array<object>) => {
				this.exCategory = result;
			});
		}
	}

	// ON CLICK TO UPDATE IMAGE AND SET THE LIGHT BOX FULL IMAGE.
	onChangeUploadImage = (event) => {
		if(event.target.files && event.target.files[0]){
			this.uploadedFile = event.target.files[0];
			this.caseAddImageForm.uploadImage = event.target.files[0].name;

			if(this.dailogData.is_edit){
				this.caseAddImageForm.disableBtn = (this.caseAddImageForm.internal.squence) ? false : true;
			}else{
				this.caseAddImageForm.disableBtn = (this.caseAddImageForm.internal.squence && this.caseAddImageForm.uploadImage) ? false : true;
			}

			const reader = new FileReader();
			const [image] = event.target.files;
			reader.readAsDataURL(image);

			reader.onload = () => {
				this.caseAddImageForm.thumbnailURL = reader.result as string;
			};
		}
	}

	// TO OPEN THE FULL IMAGE
	onClickViewImage = () => {
		this.renderer.addClass(this.lightbox.nativeElement, 'open');
		this.renderer.addClass(document.body, 'lightbox-open');
	}

	// TO CHECK THE LENGTH.
	onKeyUpLength = (event, fieldType, field, limit) => {
		this.caseAddImageForm[fieldType][field] = (event.target.value.length <= limit) ? event.target.value : event.target.value.substring(0, limit);
	}

	// TO CHECK THE SEQUANCE NO VALIDATION.
	onKeyUpValidate = event => {
		if(this.dailogData.is_edit){
			this.caseAddImageForm.disableBtn = (this.caseAddImageForm.internal.squence) ? false : true;
		}else{
			this.caseAddImageForm.disableBtn = (this.caseAddImageForm.internal.squence && this.caseAddImageForm.uploadImage) ? false : true;
		}
	}

	// ON CLICK TO REMOVE THE UPLOADED IMAGE.
	onClickRemoveImage = () => {
		this.caseAddImageForm.uploadImage = null;
		this.caseAddImageForm.disableBtn = true;
		this.caseAddImageForm.thumbnailURL = null;
	}

	// CLOSE THE LIGHT BOX.
	closeImageLightbox() {
		this.renderer.removeClass(this.lightbox.nativeElement, 'open');
		this.renderer.removeClass(document.body, 'lightbox-open');
	}

	// PREPARE THE FORM DATA AND CALL THE SAVE FUNCTION TO SAVE THE DATA IN DATABASE.
	onClickSave = () => {
		this.saveFormData.specimenCode = (this.caseAddImageForm.specimenCode) ? this.caseAddImageForm.specimenCode : '';
		this.saveFormData.fullPath = this.caseAddImageForm.uploadImage;
		this.saveFormData.name = this.caseAddImageForm.uploadImage;
		this.saveFormData.id = (this.caseAddImageForm.internal.image_id) ? this.caseAddImageForm.internal.image_id : '';
		this.saveFormData.magnification = this.caseAddImageForm.internal.magnification;
		this.saveFormData.comment = (this.caseAddImageForm.internal.comment) ? this.caseAddImageForm.internal.comment : '';
		this.saveFormData.subTypeCode = this.caseAddImageForm.external.imagesubtype;
		this.saveFormData.sequence = this.caseAddImageForm.internal.squence;
		this.saveFormData.externalName = (this.caseAddImageForm.external.imagename) ? this.caseAddImageForm.external.imagename : '';
		this.saveFormData.approveFlag = this.dailogData.approveFlag;
		this.saveFormData.extComment = (this.caseAddImageForm.internal.comment) ? this.caseAddImageForm.internal.comment : '';
		this.saveFormData.specLink = this.dailogData.specLink;
		this.saveFormData.spec = this.dailogData.spec;
		this.saveFormData.imageNumber = this.dailogData.imageNumber;
		this.saveFormData.lastUpdated = this.dailogData.lastUpdated;
		this.saveFormData.lastUpdatedUser = this.dailogData.lastUpdatedUser;
		this.saveFormData.logInfo = this.dailogData.logInfo;
		this.saveFormData.diagnosis = this.dailogData.diagnosis;
		this.saveFormData.diagnosisDesc = this.dailogData.diagnosisDesc;
		this.saveFormData.actionDiagnosis = this.dailogData.actionDiagnosis;
		this.saveFormData.diagnosisMenu = this.dailogData.diagnosisMenu;
		this.saveFormData.typeCode = this.caseAddImageForm.external.imagetype;
		this.saveFormData.mailing = this.dailogData.mailing;
		this.saveFormData.mailingYear = this.caseAddImageForm.specimenYear;
		this.saveFormData.siteCode = this.dailogData.siteCode;
		this.saveFormData.caseNumber = this.dailogData.caseNumber;
		this.saveFormData.programName = 'NGC';

		this.saveEditImageFn();
	}

	// SAVE FORM DATA SERVER CALL.
	saveEditImageFn = () => {
		if(!this.dailogData.is_edit)
			this.obervableService.changeLoaderValue(true);

		// ADD IMAGE AND UPDATE IMAGE URL SET.
		const url = (!this.dailogData.is_edit) ? 'addImage' : 'updateImage';
		this.ptImageMappingService.saveCaseAddImage(url, this.saveFormData).subscribe( result => {
			if(!this.dailogData.is_edit){
				if(result && result.imageNumber && result.imageNumber !== ''){
					// TO STORE FULL IAMGE IN S3 BUCKET.
					this.ptImageMappingService.uploadImageToS3(result.preSignedUrlForImageUpload, this.uploadedFile).subscribe( uploadResult => {
						// TO STORE THUMBNAIL IAMGE IN S3 BUCKET.
						this.ptImageMappingService.uploadImageToS3(result.preSignedUrlForThumbnailImage, this.uploadedFile).subscribe( thumbnailResult => {
							this.obervableService.changeLoaderValue(false);
							let dailogReturnData = result;
							dailogReturnData.imageName = this.saveFormData.name;
							this.dialogRef.close(dailogReturnData);
						});
					});
				} else {
					// IF ERROR OCCURRED
					this.errorTryFn('imageError');
					this.obervableService.changeLoaderValue(false);
				}
			}else{ // IF UPDATE IMAGE THEN THIS PART IS RENDERD.
				this.obervableService.changeLoaderValue(false);
				if(result && result.status){
					this.dialogRef.close(result);
				}else{
					// IF ERROR OCCURRED
					this.errorTryFn('imageError');
				}
			}
		});
	}

	// IF ERROR OCCURRED IN ADD OR UPDATE IMAGE TIME THEN IT'S SHOWING THE ERROR DAILOG.
	errorTryFn = (error_type) => {
		const dailogRef = this.dialog.open(AddImageErrorComponent, { data : { error: error_type, title:  (!this.dailogData.is_edit) ? 'Add Image' : 'Edit Image Attributes' } });
		dailogRef.beforeClosed().subscribe( result => {
			if(result.error == 'imageError'){
				this.saveEditImageFn();
			}
		});
	}
}
